export default "<div id=\"topBar\">\r\n    {{bartRoleDescription}}: {{firstLastName}}\t\t\t\t\r\n</div>"